var ShadowImage = "/static/4ba628412f69a9ad.png";

export { ShadowImage as default };
//# sourceMappingURL=shadow.png.js.map
